module.exports = __webpack_public_path__ + "static/media/paint_small.43d2cad3.webp";